<template>
  <div>
    <p v-if="displayType === 'long'">
      <template v-if="portfolio && benchmark">
        <span v-if="portfolio.equity_only_id">
          This values report is based on the equity-only portion of the portfolio.
        </span>
        <span v-if="benchmark.equity_only_id">
          This values report is based on the equity-only portion of the benchmark.
        </span>
      </template>
      <template v-else-if="portfolio">
        <span v-if="portfolio.equity_only_id">
          This values report is based on the equity-only portion of the portfolio.
        </span>
      </template>
      <template v-else-if="benchmark">
        <span v-if="benchmark.equity_only_id">
          This values report is based on the equity-only portion of the benchmark.
        </span>
      </template>
      Values alignment is based on the underlying values-based metrics that correspond to the values selected by the user.
      Alignment percentages are normalized compared to peers, where 50% Alignment is the median.
    </p>

    <p v-else>
      <template v-if="portfolio && benchmark">
        <span v-if="portfolio.equity_only_id">
          This values report is based on the equity-only portion of the portfolio.
        </span>
        <span v-if="benchmark.equity_only_id">
          This values report is based on the equity-only portion of the benchmark.
        </span>
      </template>
      <template v-else-if="portfolio">
        <span v-if="portfolio.equity_only_id">
          This values report is based on the equity-only portion of the portfolio.
        </span>
      </template>
      <template v-else-if="benchmark">
        <span v-if="benchmark.equity_only_id">
          This values report is based on the equity-only portion of the benchmark.
        </span>
      </template>
      Values alignment is based on the underlying values-based metrics that correspond to the values selected by the user. Alignment percentages are normalized compared to peers, where 50% alignment is the median. See full methodology below.
    </p>
  </div>
</template>


<script>
export default {
  name: 'ValuesMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
};
</script>
